import { THEME_COLOR } from "../../styles/colors";

// Constants used only by the HIRE feature.

export const HIRE_URL = "https://hire.amazon.com/interviewing";

export const HIRE_TEXT = {
  TITLE: "Amazon Meetings",
  TRANSCRIBING: "Transcribing...",
  STOPPED_TITLE: "Amazon Meetings stopped",
  STOPPED_NOTES: "Start taking notes if needed.",
  STOPPED_TRANSCRIPT: "You'll find transcript in Hire when it's ready.",
  GO_TO_HIRE: "Go to Hire",
  NOT_AVAILABLE_TITLE: "Start taking notes",
  REJECTED_SUFFIX: "is starting transcription...",
};

// End button: the Start button's spot, in red.
export const END_BUTTON_TOKENS = {
  buttonBackgroundColorPrimaryDefault: THEME_COLOR.CRIMSON,
  buttonBackgroundColorPrimaryHover: THEME_COLOR.CRIMSON,
  buttonBackgroundColorPrimaryPressed: THEME_COLOR.DARK_MAROON,
};

// RTMS start timing
export const SESSION_POLL_INTERVAL_MS = 5000;
export const START_TIMEOUT_MS = 15000;
export const RESTART_TIMEOUT_MS = 60000;
// The first attempt already waited 15s; wait 45s more so the backend's 60s start timeout has passed.
export const RESTART_DELAY_MS = 45000;
// Reset a rejected start if no "started" event arrives.
export const REJECTION_RESET_MS = 120000;

// Zoom in-meeting chat message posted after the start message when a LEO interviewer starts transcription.
export const LEO_INTERVIEW_CHAT_MESSAGE =
  "This interview is being transcribed. As a reminder, please do not discuss any export-controlled technical details during this session.";
